import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContextDynamicProp } from '@core/models/context-dynamic-props.model';
import { DataCollectorConfig } from '@core/models/data-collector-config.model';
import { FlowchartMode } from '@flowchart';
import { TranslocoService } from '@ngneat/transloco';

import it from './i18n/context-dynamic-props-edit.it.json';


@Component({
  selector: 'context-dynamic-props-edit',
  templateUrl: './context-dynamic-props-edit.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContextDynamicPropsEditComponent implements OnInit {

  @Input() configs: ContextDynamicProp[] = [];
  @Input() currentProcedureId?: number;
  @Input() currentProcedureStepId?: number;
  @Input() mode: FlowchartMode = 'edit';
  @Input() label?: string;
  @Input() addPropLabel?: string;

  @Output() changed = new EventEmitter<{ prop: string; collectors: DataCollectorConfig[] }[]>();

  constructor(
    private translocoSvc: TranslocoService
  ) { }

  ngOnInit(): void {
    this.translocoSvc.setTranslation(it, 'it');
  }

  addCollector(prop: string, collector: DataCollectorConfig) {
    const configs: ContextDynamicProp[] = this.configs.reduce((acc, curr) => {
      if (curr.prop === prop) {
        acc = [...acc, { ...curr, collectors: [...curr.collectors, collector] }];
      } else {
        acc = [...acc, curr];
      }
      return acc;
    }, [] as ContextDynamicProp[]);
    this.changed.emit(configs);
  }

  removeCollector(prop: string, index: number) {
    const configs: ContextDynamicProp[] = this.configs.reduce((acc, curr) => {
      if (curr.prop === prop) {
        acc = [...acc, { ...curr, collectors: [...curr.collectors.filter((c, i) => i !== index)] }];
      } else {
        acc = [...acc, curr];
      }
      return acc;
    }, [] as ContextDynamicProp[]);
    this.changed.emit(configs);
  }

  addProp(prop: string, defaultValue?: string) {
    const configs: ContextDynamicProp[] = [...this.configs, { prop, defaultValue, collectors: [] }];
    this.changed.emit(configs);
  }

  removeProp(prop: string) {
    const configs: ContextDynamicProp[] = this.configs.filter(c => c.prop !== prop);
    this.changed.emit(configs);
  }
}
